(function () {
  window.dataLayer = window.dataLayer || [];

  var pending = [];
  var flushTimer = null;
  var pixelsReady = false;

  function canPublish() {
    return typeof Shopify !== 'undefined' && Shopify.analytics && typeof Shopify.analytics.publish === 'function';
  }

  function flush() {
    if (!canPublish()) return;
    pixelsReady = true;
    while (pending.length) {
      var item = pending.shift();
      try {
        Shopify.analytics.publish(item.name, item.payload);
      } catch (e) {}
    }
  }

  function scheduleFlush() {
    if (flushTimer) return;
    var attempts = 0;
    flushTimer = setInterval(function () {
      attempts += 1;
      if (canPublish()) {
        clearInterval(flushTimer);
        flushTimer = null;
        // Pixel sandbox se pripojuje az po Shopify.analytics — chvili pockat, jinak purchase zmizi.
        setTimeout(flush, 400);
        return;
      }
      if (attempts >= 50) {
        clearInterval(flushTimer);
        flushTimer = null;
      }
    }, 100);
  }

  function storefrontPageFields() {
    return {
      page_location: window.location.href,
      page_path: window.location.pathname + window.location.search,
      page_title: document.title,
      page_referrer: document.referrer || '',
    };
  }

  window.drivetoAnalyticsPush = function drivetoAnalyticsPush(payload, options) {
    if (!payload || typeof payload !== 'object') return;
    options = options || {};
    var page = storefrontPageFields();
    payload.page_location = page.page_location;
    payload.page_path = page.page_path;
    payload.page_title = page.page_title;
    if (!payload.page_referrer) payload.page_referrer = page.page_referrer;

    if (!options.pixelOnly) {
      window.dataLayer.push(payload);
    }

    pending.push({
      name: payload.event ? 'driveto:' + payload.event : 'driveto:page_context',
      payload: payload,
    });

    if (pixelsReady) {
      flush();
    } else {
      scheduleFlush();
    }
  };

  scheduleFlush();

  window.drivetoAnalyticsPush(
    {
      event: 'page_viewed',
      page_location: window.location.href,
      page_title: document.title,
      page_referrer: document.referrer || '',
    },
    { pixelOnly: true },
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var el = target.closest('[class*="gtm-hp-"]');
      if (!el) return;

      var gtmClass = null;
      for (var i = 0; i < el.classList.length; i++) {
        var cls = el.classList[i];
        if (cls.indexOf('gtm-hp-') === 0) {
          gtmClass = cls;
          break;
        }
      }
      if (!gtmClass) return;

      window.drivetoAnalyticsPush({
        event: 'cta_click',
        gtmClass: gtmClass,
        href: el.getAttribute('href') || null,
        text: (el.textContent || '').trim().slice(0, 120) || null,
      });
    },
    true,
  );
})();
